@if (showLoader) {
  <div class="overlay">
    <static-loader [text]="text" color="white"></static-loader>
  </div>
}
